import { gql } from 'graphql-tag'

export const fragPageInfo = gql`
  fragment FragPageInfo on WPPageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`

export const fragSeoCategoryYoastFragment = gql`
  fragment FragSeoCategoryYoastFragment on TaxonomySEO {
    twitterImage {
      sourceUrl(size: MEDIUM)
    }
    twitterTitle
    twitterDescription
    title
    metaDesc
    opengraphTitle
    opengraphDescription
    opengraphType
    opengraphUrl
    opengraphSiteName
    opengraphImage {
      sourceUrl(size: MEDIUM)
    }
  }
`

export const fragSeoPostYoastFragment = gql`
  fragment FragSeoPostYoastFragment on PostTypeSEO {
    twitterImage {
      sourceUrl(size: MEDIUM)
    }
    twitterTitle
    twitterDescription
    title
    metaDesc
    opengraphTitle
    opengraphDescription
    opengraphType
    opengraphUrl
    opengraphSiteName
    opengraphImage {
      sourceUrl(size: MEDIUM)
    }
  }
`

export const fragSeoUserYoastFragment = gql`
  fragment FragSeoUserYoastFragment on SEOUser {
    twitterImage {
      sourceUrl(size: MEDIUM)
    }
    twitterTitle
    twitterDescription
    title
    metaDesc
    opengraphTitle
    opengraphDescription
    opengraphImage {
      sourceUrl(size: MEDIUM)
    }
  }
`
